import React, { Component } from 'react';
import _ from 'lodash';
import Media from 'react-media';
import PropTypes from 'prop-types';
import Table from '../LazyWidgets/Table';
import MiniTable from '../LazyWidgets/MiniTable';
import EmailWithTooltip from '../../src/components/EmailTooltip/EmailWithTooltip';
import s from './SkillsFeedbackTable.module.css';
import { getReviewedByStudentColumn } from './componentFunctions';

class SkillsSummaryTable extends Component {
  static propTypes = {
    data: PropTypes.array,
    tableStyle: PropTypes.array,
    miniTableDefaultColumn: PropTypes.string,
    arraySortBy: PropTypes.shape({
      columns: PropTypes.array,
      directions: PropTypes.array,
    }),
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.data !== nextProps.data) {
      const sortedArray = SkillsSummaryTable.sortByDefault(
        nextProps.data,
        prevState.defaultOrder
      );
      return {
        data: nextProps.data,
        tableData: sortedArray,
        arraySortBy: prevState.defaultOrder.arraySortBy,
      };
    }
    return null;
  }

  static sortByDefault(table, defaultOrder) {
    const { columns, directions } = defaultOrder.arraySortBy;
    return _.orderBy(SkillsSummaryTable.styleData(table), columns, directions);
  }

  static styleData(tData) {
    return tData.map((item) => {
      item.className = 'styledRow';
      return item;
    });
  }

  constructor(props) {
    super(props);
    this.tableSort = this.tableSort.bind(this);
    const defaultOrder = {
      arraySortBy: this.props.arraySortBy || {
        columns: [
          'numberOfStudentReview',
          'numberOfInstructorComments',
          'name',
        ],
        directions: ['asc', 'desc', 'asc'],
      },
    };
    const sortedArray = SkillsSummaryTable.sortByDefault(
      this.props.data,
      defaultOrder
    );
    this.state = {
      data: this.props.data,
      defaultOrder,
      tableData: sortedArray,
      arraySortBy: defaultOrder.arraySortBy,
    };
  }

  miniTableColumns(data) {
    const studentsFeedback = _.find(data, [
      'accessor',
      this.props.miniTableDefaultColumn
        ? this.props.miniTableDefaultColumn
        : 'numberOfStudentReview',
    ]);
    const mini = [...data];
    const indexToRemove = mini.indexOf(studentsFeedback);
    mini.splice(indexToRemove, 1);
    mini.splice(1, 0, studentsFeedback);
    return mini;
  }

  tableSort(_e, order) {
    const newTable = _.orderBy(
      this.state.tableData,
      [order.column, 'numberOfInstructorComments', 'name'],
      [order.direction, 'desc', 'asc']
    );
    this.setState({
      arraySortBy: { columns: [order.column], directions: [order.direction] },
      tableData: newTable,
    });
  }

  render() {
    const { tableData } = this.state;

    const tableColumns = [
      {
        accessor: 'name',
        Header: 'Name',
        cell: (item) => (
          <div>
            {' '}
            <span>{item.name}</span> <br />
            <EmailWithTooltip email={item.email} />
          </div>
        ),
      },
      {
        accessor: 'numberOfInstructorComments',
        Header: 'Instructor Comments',
      },
      {
        accessor: 'numberOfStudentReview',
        Header: 'Reviewed by Student',
        cell: (item) =>
          getReviewedByStudentColumn(
            item,
            'numberOfStudentReview',
            'numberOfInstructorComments'
          ),
      },
    ];
    return (
      <Media query={{ minWidth: 710 }}>
        {(matches) =>
          matches ? (
            <Table
              className={s.table}
              data={tableData}
              styling={this.props.tableStyle}
              columns={tableColumns}
              sortable
              ruled
              autosort={false}
              onSortedChange={this.tableSort}
              sortColumn={this.state.arraySortBy.columns[0]}
              sortDirection={this.state.arraySortBy.directions[0]}
              minWidth={555}
            />
          ) : (
            <MiniTable
              className={s.minitable}
              data={tableData}
              columns={this.miniTableColumns(tableColumns)}
              styling={this.props.tableStyle}
              sortable
              autosort={false}
              onSortedChange={this.tableSort}
              sortColumn={this.state.arraySortBy.columns[0]}
              sortDirection={this.state.arraySortBy.directions[0]}
              minWidth={220}
            />
          )
        }
      </Media>
    );
  }
}

export default SkillsSummaryTable;
